// extracted by mini-css-extract-plugin
module.exports = {"chatLauncher":"ChatBotLauncher_chatLauncher__1AF4h","chatLauncherBtn":"ChatBotLauncher_chatLauncherBtn__2MPAC"};